module.exports = __webpack_public_path__ + "img/true-360-vdp-badge.6ed01c89.png";